import {Dialog, DialogTitle, DialogContent, DialogActions, Typography} from '@mui/material'
import {OcButton} from './BasicOcComponents/OcButton'
import {makeOcStyles, getScrollStyle} from '@oc/styles'
import {SlideUp} from '@oc/shell-core'
import {keyBoardPressActions} from '@oc/utils'
import {DataCyProps} from './dataCyProps'
import {messages} from './translations'

const useStyles = makeOcStyles(theme => ({
    dialogRoot: {
        minWidth: '310px',
        maxWidth: '600px',
        padding: theme.spacing(4)
    },
    dialogHeader: {
        padding: 0,
        marginBottom: theme.spacing(1),
        maxHeight: '50%',
        overflow: 'auto',
        flex: 0,
        ...getScrollStyle(undefined, theme.palette.background.paper)
    },
    dialogContent: {
        padding: 0,
        marginTop: theme.spacing(1),
        ...getScrollStyle(undefined, theme.palette.background.paper)
    },
    dialogActions: {
        padding: theme.spacing(4, 0, 0, 0)
    },
    buttonMinSize: {
        minWidth: '132px'
    },
    marginRight: {
        marginRight: theme.spacing(1)
    }
}))

interface OcSimpleConfirmDialogProps extends DataCyProps {
    open: boolean
    square?: boolean
    title?: string
    content: React.ReactNode
    confirm: () => void
    cancel: () => void
    confirmLabel?: string
    cancelLabel?: string
    cancelDisabled?: boolean
    confirmDisabled?: boolean
}

export function OcSimpleConfirmDialog(props: OcSimpleConfirmDialogProps) {
    const {classes, cx} = useStyles()

    return (
        <Dialog
            open={props.open}
            data-cy={props['data-cy']}
            TransitionComponent={SlideUp}
            classes={{paper: classes.dialogRoot}}
            PaperProps={{square: props.square}}
            onKeyDown={event => {
                keyBoardPressActions(event, props.cancel, props.confirm, false, false, props.open)
            }}
        >
            <DialogTitle className={classes.dialogHeader}>
                <Typography variant="body1">{props.title || messages.getText('headers', 'confirmAction')}</Typography>
            </DialogTitle>
            <DialogContent className={classes.dialogContent}>
                {typeof props.content === 'string' ? (
                    <Typography variant="body2">{props.content}</Typography>
                ) : (
                    props.content
                )}
            </DialogContent>
            <DialogActions className={classes.dialogActions}>
                <OcButton
                    className={cx(classes.buttonMinSize, classes.marginRight)}
                    onClick={props.cancel}
                    disabled={props.cancelDisabled}
                    color="secondary"
                    data-cy="cancel"
                >
                    {props.cancelLabel || messages.getText('buttons', 'cancel')}
                </OcButton>
                <OcButton
                    className={classes.buttonMinSize}
                    onClick={props.confirm}
                    disabled={props.confirmDisabled}
                    data-cy="confirm"
                >
                    {props.confirmLabel || messages.getText('buttons', 'confirm')}
                </OcButton>
            </DialogActions>
        </Dialog>
    )
}
